module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Weather/Cloud-wind-5a36f06b351b84eab62d7b5d8bd55023.svg";